import React from 'react';
import logo from '../assets/wingitlog-fixed.png';

export default function WingitLogo({ size = 'medium' }) {
  const widths = {
    small: 140,
    medium: 220,
    large: 320,
  };

  return (
    <div style={styles.container}>
      <img
        src={logo}
        alt="Wingit"
        style={{
          width: widths[size] || widths.medium,
          maxWidth: '100%',
          height: 'auto',
          display: 'block',
        }}
      />
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
};